import { COUNTRIES, STATES } from "lib/states"
import useEvent from 'landing_pages/common/use-event'
import Inputmask from 'inputmask'
import { QuestionProps } from "landing_pages/types"
import NativeSelect, { NativeSelectItem } from "./NativeSelect"
import NativeTextField from "./NativeTextField"

const AGES = [...Array(44).keys()].map(i => String(i + 18)).concat( '62+')

Inputmask.extendDefinitions({
  '2': {
    validator: '[2-9]',
  }
})

function questionOptions(question) {
  switch(question.type) {
    case 'state':
      return STATES.map(_ => _.abbreviation)
    case 'age':
      return AGES
    case 'country':
      return COUNTRIES.map(_ => _.abbreviation)
    case 'select':
      return question.options
  }
}

export default function AgataQuestion({ question, value, setValue, isError, mapsAutoComplete, onChange, onCommit, showLabels }: QuestionProps) {
  const handleSelect = useEvent((value: string) => {
    setValue(value)
    onChange?.()
    onCommit?.()
  })

  const type = question.type
  if(type === 'text' || type === 'email' || type === 'tel' || type === 'zip') {
    const inputMask = type === 'tel' ? '(299) 299-9999' : ''
    const inputType = type === 'zip' ? 'text' : type
    return <NativeTextField
      type={inputType}
      label={question.text}
      placeholder={question.text}
      value={value}
      inputMask={inputMask}
      mapsAutoComplete={mapsAutoComplete}
      onInput={event => { setValue(event.currentTarget.value) }}
      onChange={_event => { onChange?.() }}
      error={isError}
      onBlur={_event => { onCommit?.() }}
      id={question.key}
      showLabel={showLabels}
    />
  } else {
    const options = questionOptions(question)
    return (
      <NativeSelect
        label={question.text}
        showLabel={showLabels}
        value={value ?? ''}
        onChange={handleSelect}
        placeholder={showLabels ? 'Please select' : question.text}
        error={isError}
      >
        {options.map((option: string, index: number) => (
          <NativeSelectItem
            key={index}
            label={type === 'state' ? STATES[index].name : (type === 'country' ? COUNTRIES[index].name : option)}
            value={option}
          />
        ))}
      </NativeSelect>
    )
  }
}
